import type { ComponentType } from 'react';
import { Building2, type LucideIcon } from 'lucide-react';
import { AdscripcionSolicitudModal } from './adscripcion/AdscripcionSolicitudModal';
import { ANCHO_MODAL_ADSCRIPCION } from './adscripcion/adscripcionModel';

/** Props every request modal receives from "Mis solicitudes" (or any other entry point). */
export interface SolicitudModalProps {
	onClose: () => void;
	/** Called after a request was created so the caller can refresh its list. */
	onSolicitudCreada: () => void;
	/** Width the registry asks for; the modal hands it to its `ModalShell`. */
	maxWidth: string;
}

/** Request types a researcher can create TODAY. Only wired types are listed (UAR-05). */
export type TipoSolicitudCreable = 'cambio_unidad';

export interface SolicitudTipoEntry {
	tipo: TipoSolicitudCreable;
	label: string;
	descripcion: string;
	Icon: LucideIcon;
	/** Each type owns its modal and its size (a future type may need a different one). */
	maxWidth: string;
	Modal: ComponentType<SolicitudModalProps>;
}

/**
 * Registry of the request types. The selector lists exactly these entries, even when there is only one,
 * so people get used to choosing a type before more of them exist. Do NOT add types that are not wired.
 */
export const SOLICITUD_TIPOS: readonly SolicitudTipoEntry[] = [
	{
		tipo: 'cambio_unidad',
		label: 'Cambio de unidad',
		descripcion: 'Cambia tu unidad principal o administra tus unidades adicionales.',
		Icon: Building2,
		maxWidth: ANCHO_MODAL_ADSCRIPCION,
		Modal: AdscripcionSolicitudModal,
	},
];

export function getSolicitudTipo(tipo: TipoSolicitudCreable): SolicitudTipoEntry | undefined {
	return SOLICITUD_TIPOS.find((entry) => entry.tipo === tipo);
}
